/**
 * @description - Styling for Grid, Paper, and FormControl MUI components.
 * @constant {useStyles}
 */
export const useStyles = {
  paper: {
    padding: "16px",
    textAlign: "center",
  },
  selectAllText: {
    fontWeight: 600,
    textDecoration: "underline",
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  formHelperText: {
    textAlign: "center",
  },
};

/**
 * @description - MenuProps for Select component.
 * @constant {MenuProps}
 * @default - { PaperProps: { style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250, }, }, }
 * @constant {ITEM_HEIGHT}
 * @constant {ITEM_PADDING_TOP}
 */
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * @description - Styling for MenuItem component.
 * @param {string} name - Name of the MenuItem.
 * @param {string[]} value - Value of the MenuItem.
 * @param {object} theme - Material-UI theme object.
 * @returns {object} - Material-UI styling object.
 */
export function getStyles(name, value, theme) {
  return {
    fontWeight: value.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

// CORs Headers for API call.
/**
 * @description Headers for API call.
 * @constant {Headers}
 * @default - { headers: { accept: "application/json", "force-cors": true, }, }
 */
export const Headers = {
  headers: {
    accept: "application/json",
    "force-cors": true,
  },
};

/***
 * @description List of all possible ticket status.
 * @type {string[]}
 * @constant {StatusList}
 * @default - [ "In Code Review", "Dev Complete", "Ready for Test", "In Test", "QA Pass", "Test Complete", "Completed", "Accepted" ]
 */
export const StatusList = [
  "In Progress",
  "In Code Review",
  "Dev Complete",
  "Ready for Test",
  "In Test",
  "QA Pass",
  "Test Complete",
  "Completed",
  "Accepted",
  "Released",
];
